import { capitalize } from 'lodash';
import * as ApiModels from '@/typings/api-models';
import Note from '@components/Icons/Note';
import s from './UserWorkflowActivityThread.module.scss';

type Props = {
  item: Pick<ApiModels.UserWorkflowActivity, 'type' | 'action' | 'activityType'>;
};

const getHumanReadableType = (type: string): string =>
  type
    .split('-')
    .map(word => capitalize(word))
    .join(' ');

const getHumanReadableTypeFromRollUp = (type: string): string =>
  type
    .split('-')
    .slice(0, -1)
    .map(word => capitalize(word))
    .join(' ');

const getText = (item: Props['item']): string => {
  if (item.type === ApiModels.ACTIVITY_TYPES.CREDIT_REPORT) {
    return getHumanReadableType(item.activityType);
  }

  if (item.type === ApiModels.ACTIVITY_TYPES.FORM_REQUEST) {
    return getHumanReadableType(item.activityType);
  }

  if (item.type) {
    return getHumanReadableType(item.type);
  }

  return getHumanReadableTypeFromRollUp(item.activityType);
};

const TypeColumn: React.FC<Props> = ({ item }) => {
  if (item.type === ApiModels.ACTIVITY_TYPES.CASE_NOTE) {
    return (
      <div className={s.typeColumn}>
        <Note weight="fill" size={16} color="var(--color-gray-75)" />
      </div>
    );
  }

  return (
    <div className={s.typeColumn}>
      {getText(item)}
    </div>
  );
};

export default TypeColumn;